export const AppContainerId = 'veilederhoyskoleuniversitet';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksBx = 'boks-bx';
export const BoksC = 'boks-c';
export const BoksCx = 'boks-cx';
export const BoksD = 'boks-d';
export const BoksE = 'boks-e';
export const BoksF = 'boks-f';
export const ResultatG = 'resultat-g';
export const ResultatH = 'resultat-h';
